import React from 'react';

import { withBemMod } from '@bem-react/core';

import { cnTag } from '../Tag.cn';
import type { TagBaseProps } from '../Tag.types';

import './Tag_color.css';

export type WithColorProps = {
    color?: 'red' | 'green' | 'blue' | 'purple' | 'default';
};

export const withColor = withBemMod<WithColorProps, TagBaseProps>(cnTag(), {}, (Tag) => (props) => {
    const { color } = props;
    return <Tag {...props} className={cnTag({ color }, [props.className])} />;
});
